import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CreatorCrossService from "../service/CreatorCrossService";
import Logger from "../../services/Logger";
import { trackEvent } from "../../services/GoogleAnalytics";

export default function CreatorCrossEdit() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const language = searchParams.get('language') || null;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        trackEvent("entered", { name: "CreatorCrossEdit" });
    }, []);

    useEffect(() => {
        const loadPuzzle = async () => {
            try {
                setLoading(true);
                setError(null);
                const puzzleData = await CreatorCrossService.getDraftCrossPuzzle(language);
                
                if (puzzleData && puzzleData.code === "NO_DATA") {
                    setError("No draft crossword puzzle found. Please create a new puzzle.");
                } else if (puzzleData && puzzleData.id) {
                    // Navigate to the creator-specific edit page with the puzzle ID
                    // This route will render the edit component without requiring admin auth
                    navigate(`/creator/crossword/edit/${puzzleData.id}`, { replace: true });
                } else {
                    setError("No draft crossword puzzle found.");
                }
            } catch (err) {
                Logger.error("Error loading draft crossword puzzle:", err);
                setError("Failed to load puzzle. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        loadPuzzle();
    }, [navigate, language]);

    if (loading) {
        return (
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
                <CircularProgress />
                <Typography variant="body1" sx={{ mt: 2 }}>
                    Loading puzzle...
                </Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ p: 4 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate("/creator/crossword")}
                    sx={{ mb: 2 }}
                >
                    Back to Creator
                </Button>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    // This should not be reached if navigation works, but just in case
    return (
        <Box sx={{ p: 4 }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/creator")}
                sx={{ mb: 2 }}
            >
                Back to Creator
            </Button>
            <Typography variant="h6">Redirecting to edit page...</Typography>
        </Box>
    );
}

